<div class="range-selection-dropdown" #dropdownRoot>
  @if (presetBar || timePresetBar) {
    <div class="quick-period-rows">
      <div class="quick-period-label">
        {{ presetsLabel }}
      </div>
      @if (presetBar) {
        <sui-button-group
          class="quick-periods"
          size="sm"
          [options]="dateRangePeriods"
          [ngModel]="activePeriod"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="setQuickPeriod($event)"
        ></sui-button-group>
      }
      @if (timePresetBar) {
        <sui-button-group
          class="quick-periods"
          size="sm"
          [options]="timePresetOptions"
          [ngModel]="activePeriod"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="setQuickTimePeriod($event)"
        ></sui-button-group>
      }
    </div>
  }

  <ng-content select="[range-panel-extras]"></ng-content>

  <sui-date-range-picker
    [inline]="true"
    [compact]="compact"
    [initialMonth]="initialMonth"
    [ngModel]="rangeValue"
    (ngModelChange)="onRangeChange($event)"
    [min]="minDate"
    [max]="maxDate"
  ></sui-date-range-picker>

  @if (timeDetails) {
    <div class="date-inputs">
      <div class="date-input">
        <sui-date-time-picker
          mode="time"
          displayFormat="yyyy-MM-dd HH:mm"
          [popoverContainer]="dropdownRoot"
          [(ngModel)]="fromDate"
          (ngModelChange)="onFromDateChange($event)"
        ></sui-date-time-picker>
      </div>
      <div class="date-input">
        <sui-date-time-picker
          mode="time"
          displayFormat="yyyy-MM-dd HH:mm"
          [popoverContainer]="dropdownRoot"
          [(ngModel)]="toDate"
          (ngModelChange)="onFromDateChange($event)"
        ></sui-date-time-picker>
      </div>
    </div>
  }
</div>
